export function useEnterLeaveFunc(cb, isPristine, delay) {
    if (isPristine === void 0) { isPristine = false; }
    if (delay === void 0) { delay = 800; }
    var mouseLeaveTimer;
    function handleMouseLeave() {
        if (isPristine)
            return;
        mouseLeaveTimer = window.setTimeout(cb, delay);
    }
    function handleMouseEnter() {
        if (isPristine)
            return;
        clearTimeout(mouseLeaveTimer);
    }
    return [handleMouseEnter, handleMouseLeave];
}
//# sourceMappingURL=useEnterLeaveFunc.js.map